import styled from "styled-components";

export const PostEditorWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  & > .fade-enter {
    opacity: 0;
    transform: ${(props) =>
      props.transitionDirection === "top"
        ? "translateY(-20%)"
        : props.transitionDirection === "bottom"
        ? "translateY(20%)"
        : props.transitionDirection === "right"
        ? "translateX(-20%)"
        : "translateX(20%)"};
  }
  & > .fade-exit {
    opacity: 1;
    transform: translate(0, 0);
  }
  & > .fade-enter-active {
    opacity: 1;
    transform: translate(0, 0);
  }
  & > .fade-exit-active {
    opacity: 0;
    transform: ${(props) =>
      props.transitionDirection === "top"
        ? "translateY(20%)"
        : props.transitionDirection === "bottom"
        ? "translateY(-20%)"
        : props.transitionDirection === "right"
        ? "translateX(20%)"
        : "translateX(-20%)"};
  }
  & > .fade-enter-active,
  & > .fade-exit-active {
    transition: opacity 0.14s, transform 0.14s;
  }
`;
